var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{attrs:{"isModalStatic":true,"isHideHeaderCloseButton":true,"componentName":"GoLoginModal","firstButtonText":"取消","secondButtonText":"確定"},on:{"secondFn":_vm.redirectToLogin},scopedSlots:_vm._u([{key:"body",fn:function(){return [_c('h3',{class:_vm.isMobile ? 'text-center' : 'align center'},[_vm._v("您已是神腦生活會員請直接登入")])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }